export default __webpack_public_path__ + "static/media/hp.e53f0f4d.png";